import { render, staticRenderFns } from "./app-languageSelector.vue?vue&type=template&id=53d5bb9e"
import script from "./app-languageSelector.vue?vue&type=script&lang=js"
export * from "./app-languageSelector.vue?vue&type=script&lang=js"
import style0 from "./app-languageSelector.vue?vue&type=style&index=0&id=53d5bb9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports